var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FaqSection',{staticClass:"black-friday-faq",attrs:{"title":_vm.faqTitle,"items":_vm.faqItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }